import { GridColDef } from "@mui/x-data-grid";
import { useTranslate } from "@refinedev/core";

import { DataGrid } from "@shared/components/DataGrid";
import { TableCell } from "@shared/components";
import { usePaginatedTable } from "@shared/hooks";
import { PartnerMonthlySnapshot } from "@modules/partners/types";
import { formatCurrency } from "@core/utils/masks";

export function SnapshotsTab() {
  const translate = useTranslate();

  const { rows, loading, ...tableProps } = usePaginatedTable<PartnerMonthlySnapshot>({
    resource: "v1/partner_monthly_snapshot_admin",
    sorters: { ordering: "-id" },
  });

  const columns: GridColDef[] = [
    {
      field: "partner",
      headerName: translate("v1/partner_monthly_admin.fields.partner"),
      minWidth: 200,
      renderCell: ({ value }) => <TableCell.Text value={value} textAlign="left" />,
    },
    {
      field: "year",
      headerName: translate("v1/partner_monthly_admin.fields.year"),
      minWidth: 100,
      renderCell: ({ value }) => <TableCell.Text value={value} />,
    },
    {
      field: "month",
      headerName: translate("v1/partner_monthly_admin.fields.month"),
      minWidth: 100,
      renderCell: ({ value }) => <TableCell.Text value={value} />,
    },
    {
      field: "total_mrr",
      headerName: translate("v1/partner_monthly_admin.fields.total_mrr"),
      minWidth: 140,
      renderCell: ({ value }) => (
        <TableCell.Text value={formatCurrency(value)} />
      ),
    },
    {
      field: "total_commission",
      headerName: translate("v1/partner_monthly_admin.fields.total_commission"),
      minWidth: 160,
      renderCell: ({ value }) => (
        <TableCell.Text value={formatCurrency(value)} />
      ),
    },
    {
      field: "referrals_count",
      headerName: translate("v1/partner_monthly_admin.fields.referrals_count"),
      minWidth: 140,
      renderCell: ({ value }) => <TableCell.Text value={value} />,
    },
    {
      field: "created_at",
      headerName: translate("v1/partner_monthly_admin.fields.created_at"),
      minWidth: 160,
      renderCell: ({ value }) => <TableCell.Date value={value} />,
    },
  ];

  return <DataGrid {...tableProps} rows={rows} columns={columns} loading={loading} />;
}
